import {parseNumber} from '../../utils/numerals/parseNumber';
import {trigger} from '../../utils/events/trigger';
import {monthsToYears} from '../../utils/numerals/monthsToYears';
import {spaceNumber} from '../../utils/numerals/spaceNumber';

export const initRangeOne = () => {
	const elements = document.querySelectorAll( 'div.range-one' );

	if ( !elements.length )
	{
		return;
	}

	let rangeOneHandler = null;
	let rangeOneInput = null;
	let rangeOneInputTimeout = 0;

	const preventDefault = ( evt ) => {
		evt.preventDefault();
	}	
	const disableScroll = () => {
		document.body.addEventListener( 'touchmove', preventDefault, { passive: false });
	}
	const enableScroll = () => {
		document.body.removeEventListener( 'touchmove', preventDefault );
	}

	const initButton = ( evt ) => {
		document.body.classList.add( 'range-one-dragging' );
		rangeOneHandler = evt.target;

		disableScroll();
	};

	const moveButton = ( x ) => {
		if ( !document.body.classList.contains( 'range-one-dragging' ) )
		{
			return;
		}

		const position = rangeOneHandler.closest( 'div.range-one' ).querySelector( 'div.controls' ).getBoundingClientRect().left;
		const width = rangeOneHandler.closest( 'div.range-one' ).querySelector( 'div.controls' ).offsetWidth;
		let newPosition = ( x - position ) / width * 100;

		newPosition = newPosition < 0 ? newPosition = 0 : newPosition > 100 ? newPosition = 100 : newPosition;
		
		updateRangeOne( newPosition );
	};

	const releaseButton = () => {
		if ( !document.body.classList.contains( 'range-one-dragging' ) )
		{
			return;
		}

		enableScroll();

		document.body.classList.remove( 'range-one-dragging' );
		trigger( rangeOneHandler.closest( 'div.range-one' ).querySelector( 'input.user-value' ), 'change' );
		rangeOneHandler = null;
	};

	const updateRangeOne = ( argument ) => {
		let container = null;
		const dotPosition = 0;
		const isFloat = false;

		if ( typeof argument === 'number' && rangeOneHandler !== null )
		{
			container = rangeOneHandler.closest( 'div.range-one' );
		}
		else if ( rangeOneInput !== null )
		{
			container = rangeOneInput.closest( 'div.range-one' );
		}
		else
		{
			container = argument.closest( 'div.range-one' );
		}

		if ( container === null )
		{
			return;
		}

		const userValueMin = parseNumber( container.querySelector( 'input.user-value' ).getAttribute( 'min' ), isFloat );
		const min = 0;
		const max = parseNumber( container.querySelector( 'input.user-value' ).getAttribute( 'max' ), isFloat ) - userValueMin;
		const dataType = container.querySelector( 'div.controls' ).getAttribute( 'data-type' );
		let uValue = null;

		if ( typeof argument === 'number' && rangeOneHandler !== null )
		{
			uValue = ( max - min ) / 100 * argument;
		}
		else if ( rangeOneInput !== null )
		{
			if ( dataType === 'years' )
			{
				uValue = monthsToYears( argument.match( /\d+/g ) );
			}
			else if ( +argument.replace( /[^0-9]+/g, '' ) )
			{
				uValue = +argument.replace( /[^0-9]+/g, '' ) - userValueMin;
			}
			else
			{
				uValue = 0;
			}

			rangeOneInput = null;
		}
		else 
		{
			uValue = parseNumber( container.querySelector( 'input.user-value' ).value, isFloat ) - userValueMin;
		}

		uValue = isNaN( uValue ) || uValue < min ? min : uValue > max ? max : uValue;

		uValue = parseNumber( uValue, isFloat );

		const vValue = uValue * 100 / ( max - min );

		container.querySelector( 'button.handle' ).style.left = vValue + '%';
		container.querySelector( 'span.range' ).style.width = vValue + '%';

		const inputUserValueVal = ( uValue + userValueMin ).toFixed( dotPosition );

		const userValue = container.querySelector( 'input.user-value' );

		if ( dataType === 'years' )
		{
			userValue.setAttribute( 'data-value', inputUserValueVal );
			userValue.value = monthsToYears( inputUserValueVal );
		}
		else if ( dataType === 'price' )
		{
			userValue.value = `${spaceNumber( inputUserValueVal )} ₽`;
		}
		else
		{
			userValue.value =inputUserValueVal;
		}
	};

	const clearInput = ( evt ) => {
		if ( !evt.target.hasAttribute( 'readonly' ))
		{
			evt.target.value = '';
		}	
	}

	[ ...elements ].forEach( ( elem ) => {
		elem.querySelector( 'input.user-value' ).value = elem.querySelector( 'input.user-value' ).getAttribute( 'value' );
		updateRangeOne( elem );

		elem.querySelector( 'input' ).addEventListener( 'keyup', ( evt ) => {
			if ( !/\d|\s/.test( evt.key ) && evt.key !== 'Backspace' && evt.key !== 'Delete' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowRight' )
			{
				evt.preventDefault();
				return;
			}

			clearTimeout( rangeOneInputTimeout );
			rangeOneInput = evt.target;

			rangeOneInputTimeout = setTimeout( () => {
				updateRangeOne( rangeOneInput.value );
			}, 1000 );
		} );
		
		elem.querySelector( 'input.user-value' ).addEventListener( 'mousedown', clearInput );
		elem.querySelector( 'button.handle' ).addEventListener( 'mousedown', initButton );
		elem.querySelector( 'button.handle' ).addEventListener( 'touchstart', initButton, {passive: true} );
	} );

	document.body.addEventListener( 'mousemove', ( evt ) => {
		const coord = evt.pageX;

		moveButton( coord );
	} );

	document.body.addEventListener( 'touchmove', ( evt ) => {
		const coord = evt.touches[0].pageX;

		moveButton( coord );
	} );

	document.body.addEventListener( 'mousedown', ( evt ) => {
		const coord = evt.pageX;

		moveButton( coord );
	} );

	document.body.addEventListener( 'mouseup', releaseButton );
	document.body.addEventListener( 'touchend', releaseButton );
};

